import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelJuniorPilotRequest,
  failJuniorPilot,
  setJuniorPilot,
  setJuniorPilotFromApi,
  updateJuniorPilot,
  updateJuniorPilotFromApi,
} from './junior-pilot.actions';

/**
 * Service to handle async JuniorPilot actions
 */
@Injectable()
export class JuniorPilotEffect {
  /**
   * Set the state with the reply content, dispatch failJuniorPilot if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setJuniorPilotFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setJuniorPilot({ model: reply, requestId: action.requestId }),
        (error, action) => of(failJuniorPilot({ error, requestId: action.requestId })),
        cancelJuniorPilotRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failJuniorPilot if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateJuniorPilotFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateJuniorPilot({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failJuniorPilot({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
